export const requestOTPAPI = async (post, payload) =>
  post("/auth/sendOTPForContactVerification", payload);

export const verifyOTPAPI = async (post, payload) =>
  post("/auth/verifyOTPForContactVerification", payload);
